import { createSlice } from "@reduxjs/toolkit";
import { config } from "../utils/Constants";

const initialState = {
  formValues: {},
  "getfieldByStepId-226": {
    fields: [
      {
        id: 117,
        title: "Company Logo (Optimal size 300 x 300px)",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 1,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 118,
        title: "OWNERSHIP PROFILE",
        placeHolder: "+ ADD ANOTHER SHAREHOLDER",
        toolTip:
          "Ownership of Shareholders: Add individuals or entities possess ownership shares exceeding 25%, or add maximum up to 3 owners who possess the largest shares in the company. .",
        value: "",
        type: 22,
        boundedId: 0,
        orderId: 2,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [160, 119, 120, 121, 122, 123, 124, 125, 126, 127],
        options: [],
      },
      {
        id: 119,
        title: "Ownership Percentage",
        placeHolder:
          "Ownership Percentage                                        %",
        toolTip: null,
        value: "20",
        type: 2,
        boundedId: 0,
        orderId: 4,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 120,
        title: "First Name",
        placeHolder: "First Name",
        toolTip: null,
        value: "Kanj",
        type: 1,
        boundedId: 0,
        orderId: 5,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 121,
        title: "Family Name",
        placeHolder: "Family Name",
        toolTip: null,
        value: "Kanj",
        type: 1,
        boundedId: 0,
        orderId: 5,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 122,
        title: "Date of Birth",
        placeHolder: "Date of Birth",
        toolTip: null,
        value: "19/11/1999",
        type: 9,
        boundedId: 0,
        orderId: 6,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 123,
        title: "Nationality",
        placeHolder: "Nationality",
        toolTip: null,
        value: "Limar",
        type: 10,
        boundedId: 0,
        orderId: 6,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 124,
        title: "Father’s Name",
        placeHolder: "Father’s Name",
        toolTip: null,
        value: "Zaher",
        type: 1,
        boundedId: 0,
        orderId: 7,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 125,
        title: "Residence City/Country",
        placeHolder: "Residence City/Country",
        toolTip: null,
        value: "Limar",
        type: 10,
        boundedId: 0,
        orderId: 8,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 126,
        title: "Phone Number",
        placeHolder: "+961",
        toolTip: null,
        value: "9613759505",
        type: 2,
        boundedId: 0,
        orderId: 9,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 127,
        title: "E-mail",
        placeHolder: "name@name.com",
        toolTip: null,
        value: "HasanKanj19@gmail.com",
        type: 13,
        boundedId: 0,
        orderId: 9,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 128,
        title: "Company’s Assets in USD",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 13,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 129,
        title: "Real estate value (amount)",
        placeHolder: "$     000,000.00",
        toolTip: null,
        value: "100000",
        type: 2,
        boundedId: 0,
        orderId: 14,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 130,
        title: "Annual Sales/Turnover",
        placeHolder: "$     000,000 to 000,000",
        toolTip: null,
        value: "300,000 to 600,000",
        type: 7,
        boundedId: 0,
        orderId: 15,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "≤50,000",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "50,000 to 100,000",
            nestedFields: [],
          },
          {
            optionId: 3,
            name: "100,000 to 300,000",
            nestedFields: [],
          },
          {
            optionId: 4,
            name: "300,000 to 600,000",
            nestedFields: [],
          },
          {
            optionId: 5,
            name: "600,000 to 1,000,000",
            nestedFields: [],
          },
          {
            optionId: 6,
            name: "1,000,000 to 1,500,000",
            nestedFields: [],
          },
          {
            optionId: 7,
            name: "1,500,000 to 2,000,000",
            nestedFields: [],
          },
          {
            optionId: 8,
            name: "2,000,000 to 3,000,000",
            nestedFields: [],
          },
          {
            optionId: 9,
            name: "3,000,000 to 5,000,000",
            nestedFields: [],
          },
          {
            optionId: 10,
            name: "> 5,000,000",
            nestedFields: [],
          },
        ],
      },
      {
        id: 131,
        title: "Source of Funds",
        placeHolder: "Source of Funds",
        toolTip: null,
        value: "Test",
        type: 1,
        boundedId: 0,
        orderId: 16,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 132,
        title: "Tax residence Country",
        placeHolder: "Country",
        toolTip: null,
        value: "Limar",
        type: 10,
        boundedId: 0,
        orderId: 17,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 133,
        title: "Taxation Number",
        placeHolder: "123 456 789",
        toolTip: null,
        value: "55662225",
        type: 2,
        boundedId: 0,
        orderId: 18,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 134,
        title:
          "Financial Assets: (Deposits with banks, Securities, Shares, Bonds, other…)",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 19,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 135,
        title: "Amount USD",
        placeHolder: "$     000,000.00",
        toolTip: null,
        value: "8000",
        type: 2,
        boundedId: 0,
        orderId: 20,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 136,
        title: "Description of Assets",
        placeHolder: "Description of Assets",
        toolTip: null,
        value: "Asset",
        type: 1,
        boundedId: 0,
        orderId: 21,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 137,
        title: "Expected Deposit per year",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 22,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 138,
        title: "Amount USD",
        placeHolder: "$     000,000.00",
        toolTip: null,
        value: "90000",
        type: 2,
        boundedId: 0,
        orderId: 23,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 139,
        title: "Source of Deposits/funds:",
        placeHolder: null,
        toolTip: null,
        value: "1",
        type: 6,
        boundedId: 0,
        orderId: 24,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Inside Lebanon",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Outside Lebanon",
            nestedFields: [91],
          },
        ],
      },
      {
        id: 140,
        title: "Beneficial Right’s Owner",
        placeHolder: null,
        toolTip: null,
        value: "First Name, Father’s Name, Last Name",
        type: 3,
        boundedId: 0,
        orderId: 25,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 141,
        title: "Full Name",
        placeHolder: "First Name, Father’s Name, Last Name",
        toolTip: null,
        value: "",
        type: 1,
        boundedId: 0,
        orderId: 26,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 142,
        title: "If BRO is other than the legal entity owner:",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 4,
        boundedId: 0,
        orderId: 27,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 143,
        title: "Reason",
        placeHolder: "Reason",
        toolTip: null,
        value: "Reason",
        type: 1,
        boundedId: 0,
        orderId: 28,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 144,
        title: "LEGAL DOCUMENTS",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 29,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 145,
        title: "Certificate of Incorporation",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 30,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 146,
        title: "Minutes of Founders General Assembly",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 30,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Male",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Female",
            nestedFields: [],
          },
        ],
      },
      {
        id: 147,
        title: "Domiciliation Letter",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 32,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 148,
        title: "Article of Association",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 32,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 149,
        title: "Commercial Circular",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 33,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 150,
        title: "Business Licenses",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 33,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 151,
        title: "Commercial Registry Application",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 34,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 152,
        title: "Bank Statement of Capital Deposit",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 34,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Resident",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Non-Resident",
            nestedFields: [],
          },
        ],
      },
      {
        id: 153,
        title: "Minutes of First Board of Directors",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 35,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Single",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Married",
            nestedFields: [],
          },
          {
            optionId: 3,
            name: "Divorced",
            nestedFields: [],
          },
          {
            optionId: 4,
            name: "Widower",
            nestedFields: [],
          },
        ],
      },
      {
        id: 154,
        title: "Identity of Shareholders / Owners",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 36,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 155,
        title: "Names of legal representatives:",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 9,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 156,
        title: "Chairman of the Board",
        placeHolder: "Name Chairman of the Board",
        toolTip: null,
        value: "Lea Sarkis",
        type: 1,
        boundedId: 0,
        orderId: 10,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 157,
        title: "General Manager",
        placeHolder: "Name General Manager",
        toolTip: null,
        value: "hasan Kanj",
        type: 1,
        boundedId: 0,
        orderId: 11,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 158,
        title: "Manager for Trading Companies",
        placeHolder: "Name Manager for Trading Companies",
        toolTip: null,
        value: "hasan Kanj",
        type: 1,
        boundedId: 0,
        orderId: 12,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 159,
        title: "Number of Employees",
        placeHolder: "12345",
        toolTip: null,
        value: "555",
        type: 2,
        boundedId: 0,
        orderId: 12,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 160,
        title: "",
        placeHolder: "",
        toolTip: "",
        value: "2",
        type: 5,
        boundedId: 0,
        orderId: 3,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Individual",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Company",
            nestedFields: [],
          },
        ],
      },
    ],
  },
  "getfieldByStepId-227": {
    fields: [
      {
        id: 117,
        title: "Company Logo (Optimal size 300 x 300px)",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 1,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 118,
        title: "OWNERSHIP PROFILE",
        placeHolder: "+ ADD ANOTHER SHAREHOLDER",
        toolTip:
          "Ownership of Shareholders: Add individuals or entities possess ownership shares exceeding 25%, or add maximum up to 3 owners who possess the largest shares in the company. .",
        value: "",
        type: 22,
        boundedId: 0,
        orderId: 2,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [160, 119, 120, 121, 122, 123, 124, 125, 126, 127],
        options: [],
      },
      {
        id: 119,
        title: "Ownership Percentage",
        placeHolder:
          "Ownership Percentage                                        %",
        toolTip: null,
        value: "20",
        type: 2,
        boundedId: 0,
        orderId: 4,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 120,
        title: "First Name",
        placeHolder: "First Name",
        toolTip: null,
        value: "Kanj",
        type: 1,
        boundedId: 0,
        orderId: 5,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 121,
        title: "Family Name",
        placeHolder: "Family Name",
        toolTip: null,
        value: "Kanj",
        type: 1,
        boundedId: 0,
        orderId: 5,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 122,
        title: "Date of Birth",
        placeHolder: "Date of Birth",
        toolTip: null,
        value: "19/11/1999",
        type: 9,
        boundedId: 0,
        orderId: 6,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 123,
        title: "Nationality",
        placeHolder: "Nationality",
        toolTip: null,
        value: "Limar",
        type: 10,
        boundedId: 0,
        orderId: 6,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 124,
        title: "Father’s Name",
        placeHolder: "Father’s Name",
        toolTip: null,
        value: "Zaher",
        type: 1,
        boundedId: 0,
        orderId: 7,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 125,
        title: "Residence City/Country",
        placeHolder: "Residence City/Country",
        toolTip: null,
        value: "Limar",
        type: 10,
        boundedId: 0,
        orderId: 8,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 126,
        title: "Phone Number",
        placeHolder: "+961",
        toolTip: null,
        value: "9613759505",
        type: 2,
        boundedId: 0,
        orderId: 9,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 127,
        title: "E-mail",
        placeHolder: "name@name.com",
        toolTip: null,
        value: "HasanKanj19@gmail.com",
        type: 13,
        boundedId: 0,
        orderId: 9,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 128,
        title: "Company’s Assets in USD",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 13,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 129,
        title: "Real estate value (amount)",
        placeHolder: "$     000,000.00",
        toolTip: null,
        value: "100000",
        type: 2,
        boundedId: 0,
        orderId: 14,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 130,
        title: "Annual Sales/Turnover",
        placeHolder: "$     000,000 to 000,000",
        toolTip: null,
        value: "300,000 to 600,000",
        type: 7,
        boundedId: 0,
        orderId: 15,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "≤50,000",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "50,000 to 100,000",
            nestedFields: [],
          },
          {
            optionId: 3,
            name: "100,000 to 300,000",
            nestedFields: [],
          },
          {
            optionId: 4,
            name: "300,000 to 600,000",
            nestedFields: [],
          },
          {
            optionId: 5,
            name: "600,000 to 1,000,000",
            nestedFields: [],
          },
          {
            optionId: 6,
            name: "1,000,000 to 1,500,000",
            nestedFields: [],
          },
          {
            optionId: 7,
            name: "1,500,000 to 2,000,000",
            nestedFields: [],
          },
          {
            optionId: 8,
            name: "2,000,000 to 3,000,000",
            nestedFields: [],
          },
          {
            optionId: 9,
            name: "3,000,000 to 5,000,000",
            nestedFields: [],
          },
          {
            optionId: 10,
            name: "> 5,000,000",
            nestedFields: [],
          },
        ],
      },
      {
        id: 131,
        title: "Source of Funds",
        placeHolder: "Source of Funds",
        toolTip: null,
        value: "Test",
        type: 1,
        boundedId: 0,
        orderId: 16,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 132,
        title: "Tax residence Country",
        placeHolder: "Country",
        toolTip: null,
        value: "Limar",
        type: 10,
        boundedId: 0,
        orderId: 17,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 133,
        title: "Taxation Number",
        placeHolder: "123 456 789",
        toolTip: null,
        value: "55662225",
        type: 2,
        boundedId: 0,
        orderId: 18,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 134,
        title:
          "Financial Assets: (Deposits with banks, Securities, Shares, Bonds, other…)",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 19,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 135,
        title: "Amount USD",
        placeHolder: "$     000,000.00",
        toolTip: null,
        value: "8000",
        type: 2,
        boundedId: 0,
        orderId: 20,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 136,
        title: "Description of Assets",
        placeHolder: "Description of Assets",
        toolTip: null,
        value: "Asset",
        type: 1,
        boundedId: 0,
        orderId: 21,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 137,
        title: "Expected Deposit per year",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 22,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 138,
        title: "Amount USD",
        placeHolder: "$     000,000.00",
        toolTip: null,
        value: "90000",
        type: 2,
        boundedId: 0,
        orderId: 23,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 139,
        title: "Source of Deposits/funds:",
        placeHolder: null,
        toolTip: null,
        value: "1",
        type: 6,
        boundedId: 0,
        orderId: 24,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Inside Lebanon",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Outside Lebanon",
            nestedFields: [91],
          },
        ],
      },
      {
        id: 140,
        title: "Beneficial Right’s Owner",
        placeHolder: null,
        toolTip: null,
        value: "First Name, Father’s Name, Last Name",
        type: 3,
        boundedId: 0,
        orderId: 25,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 141,
        title: "Full Name",
        placeHolder: "First Name, Father’s Name, Last Name",
        toolTip: null,
        value: "",
        type: 1,
        boundedId: 0,
        orderId: 26,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 142,
        title: "If BRO is other than the legal entity owner:",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 4,
        boundedId: 0,
        orderId: 27,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 143,
        title: "Reason",
        placeHolder: "Reason",
        toolTip: null,
        value: "Reason",
        type: 1,
        boundedId: 0,
        orderId: 28,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 144,
        title: "LEGAL DOCUMENTS",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 29,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 145,
        title: "Certificate of Incorporation",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 30,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 146,
        title: "Minutes of Founders General Assembly",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 30,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Male",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Female",
            nestedFields: [],
          },
        ],
      },
      {
        id: 147,
        title: "Domiciliation Letter",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 32,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 148,
        title: "Article of Association",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 32,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 149,
        title: "Commercial Circular",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 33,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 150,
        title: "Business Licenses",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 33,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 151,
        title: "Commercial Registry Application",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 34,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 152,
        title: "Bank Statement of Capital Deposit",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 34,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Resident",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Non-Resident",
            nestedFields: [],
          },
        ],
      },
      {
        id: 153,
        title: "Minutes of First Board of Directors",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 35,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Single",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Married",
            nestedFields: [],
          },
          {
            optionId: 3,
            name: "Divorced",
            nestedFields: [],
          },
          {
            optionId: 4,
            name: "Widower",
            nestedFields: [],
          },
        ],
      },
      {
        id: 154,
        title: "Identity of Shareholders / Owners",
        placeHolder: "Choose Photo",
        toolTip: null,
        value: "",
        type: 21,
        boundedId: 0,
        orderId: 36,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 155,
        title: "Names of legal representatives:",
        placeHolder: null,
        toolTip: null,
        value: "",
        type: 3,
        boundedId: 0,
        orderId: 9,
        isMandatory: false,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 156,
        title: "Chairman of the Board",
        placeHolder: "Name Chairman of the Board",
        toolTip: null,
        value: "Lea Sarkis",
        type: 1,
        boundedId: 0,
        orderId: 10,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 157,
        title: "General Manager",
        placeHolder: "Name General Manager",
        toolTip: null,
        value: "hasan Kanj",
        type: 1,
        boundedId: 0,
        orderId: 11,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 158,
        title: "Manager for Trading Companies",
        placeHolder: "Name Manager for Trading Companies",
        toolTip: null,
        value: "hasan Kanj",
        type: 1,
        boundedId: 0,
        orderId: 12,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 159,
        title: "Number of Employees",
        placeHolder: "12345",
        toolTip: null,
        value: "555",
        type: 2,
        boundedId: 0,
        orderId: 12,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [],
      },
      {
        id: 160,
        title: "",
        placeHolder: "",
        toolTip: "",
        value: "2",
        type: 5,
        boundedId: 0,
        orderId: 3,
        isMandatory: true,
        isNestedField: false,
        isPadded: false,
        isDisabled: false,
        length: 100,
        linkedFields: [],
        options: [
          {
            optionId: 1,
            name: "Individual",
            nestedFields: [],
          },
          {
            optionId: 2,
            name: "Company",
            nestedFields: [],
          },
        ],
      },
    ],
  },
  corporatedata: {},
  stepid: 26,
//   finalStep: {
//     groupedFields: {
//       "COMPANY PROFILE": [
//         {
//           fieldId: 96,
//           displayText: "Company Name",
//           value: "Eliasstest",
//           type: 1,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 97,
//           displayText: "Company Legal Form",
//           value: "3",
//           type: 7,
//           isModifiable: false,
//           options: [
//             {
//               optionId: 1,
//               name: "Joint Stock Company S.A.L.",
//               nestedFields: [],
//             },
//             {
//               optionId: 2,
//               name: "Limited Liability Company (SARL)",
//               nestedFields: [],
//             },
//             {
//               optionId: 3,
//               name: "Joint Liability Company",
//               nestedFields: [],
//             },
//             {
//               optionId: 4,
//               name: "Limited Partnership",
//               nestedFields: [],
//             },
//             {
//               optionId: 5,
//               name: "Undeclared Partnership",
//               nestedFields: [],
//             },
//             {
//               optionId: 6,
//               name: "Limited Partnership by Shares",
//               nestedFields: [],
//             },
//             {
//               optionId: 7,
//               name: "Holding Company",
//               nestedFields: [],
//             },
//             {
//               optionId: 8,
//               name: "Offshore Company",
//               nestedFields: [],
//             },
//             {
//               optionId: 9,
//               name: "Freelancer",
//               nestedFields: [],
//             },
//             {
//               optionId: 10,
//               name: "Government",
//               nestedFields: [],
//             },
//             {
//               optionId: 11,
//               name: "Association",
//               nestedFields: [],
//             },
//             {
//               optionId: 12,
//               name: "Other",
//               nestedFields: [],
//             },
//           ],
//         },
//         {
//           fieldId: 98,
//           displayText: "Date of incorporation",
//           value: "2025-08-30",
//           type: 9,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 100,
//           displayText: "Commercial Register Place",
//           value: "Test",
//           type: 1,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 99,
//           displayText: "Commercial Register Number",
//           value: "78787871",
//           type: 2,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 100,
//           displayText: "Commercial Register Place",
//           value: "Tets",
//           type: 1,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 101,
//           displayText: "Commercial Register Date",
//           value: "2025-08-30",
//           type: 9,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 102,
//           displayText: "Type of Business",
//           value: "5",
//           type: 7,
//           isModifiable: false,
//           options: [
//             {
//               optionId: 1,
//               name: "Advertising & Marketing",
//               nestedFields: [],
//             },
//             {
//               optionId: 2,
//               name: "Automotive",
//               nestedFields: [],
//             },
//             {
//               optionId: 3,
//               name: "Beauty & Health",
//               nestedFields: [],
//             },
//             {
//               optionId: 4,
//               name: "Business & Consulting Services",
//               nestedFields: [],
//             },
//             {
//               optionId: 5,
//               name: "Cargo & Freight",
//               nestedFields: [],
//             },
//             {
//               optionId: 6,
//               name: "Cleaning & Maintenance",
//               nestedFields: [],
//             },
//             {
//               optionId: 7,
//               name: "Construction",
//               nestedFields: [],
//             },
//             {
//               optionId: 8,
//               name: "Construction Materials",
//               nestedFields: [],
//             },
//             {
//               optionId: 9,
//               name: "Distribution Services",
//               nestedFields: [],
//             },
//             {
//               optionId: 10,
//               name: "Educational Institution",
//               nestedFields: [],
//             },
//             {
//               optionId: 11,
//               name: "Financial Services",
//               nestedFields: [],
//             },
//             {
//               optionId: 12,
//               name: "Food & Beverage",
//               nestedFields: [],
//             },
//             {
//               optionId: 13,
//               name: "Healthcare",
//               nestedFields: [],
//             },
//             {
//               optionId: 14,
//               name: "Hospitality",
//               nestedFields: [],
//             },
//             {
//               optionId: 15,
//               name: "Import & Export",
//               nestedFields: [],
//             },
//             {
//               optionId: 16,
//               name: "Industrial Supplies",
//               nestedFields: [],
//             },
//             {
//               optionId: 17,
//               name: "Insurance Company",
//               nestedFields: [],
//             },
//             {
//               optionId: 18,
//               name: "Legal Services",
//               nestedFields: [],
//             },
//             {
//               optionId: 19,
//               name: "Manufacturing",
//               nestedFields: [],
//             },
//             {
//               optionId: 20,
//               name: "Media & News",
//               nestedFields: [],
//             },
//             {
//               optionId: 21,
//               name: "NGO",
//               nestedFields: [],
//             },
//             {
//               optionId: 22,
//               name: "Petrol & Gas",
//               nestedFields: [],
//             },
//             {
//               optionId: 23,
//               name: "Pharmacies",
//               nestedFields: [],
//             },
//             {
//               optionId: 24,
//               name: "Real Estate & Construction",
//               nestedFields: [],
//             },
//             {
//               optionId: 25,
//               name: "Retail Business",
//               nestedFields: [],
//             },
//             {
//               optionId: 26,
//               name: "Science, Technology & Engineering",
//               nestedFields: [],
//             },
//             {
//               optionId: 27,
//               name: "Telecommuncations",
//               nestedFields: [],
//             },
//             {
//               optionId: 28,
//               name: "Transportation Services",
//               nestedFields: [],
//             },
//             {
//               optionId: 29,
//               name: "Travel Agency",
//               nestedFields: [],
//             },
//             {
//               optionId: 30,
//               name: "Wood Trading",
//               nestedFields: [],
//             },
//             {
//               optionId: 31,
//               name: "Army",
//               nestedFields: [],
//             },
//             {
//               optionId: 32,
//               name: "Sports & Leisure",
//               nestedFields: [],
//             },
//             {
//               optionId: 33,
//               name: "Agriculture",
//               nestedFields: [],
//             },
//             {
//               optionId: 34,
//               name: "Esim",
//               nestedFields: [],
//             },
//           ],
//         },
//         {
//           fieldId: 103,
//           displayText: "Detailed Activity",
//           value: "Testts",
//           type: 1,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 104,
//           displayText: "Company Address",
//           value: "Germany",
//           type: 20,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 106,
//           displayText: "Business Mobile Phone Number",
//           value: "78787873",
//           type: 2,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 105,
//           displayText: "Business Fixed Phone Number",
//           value: "78787872",
//           type: 2,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 106,
//           displayText: "Business Mobile Phone Number",
//           value: "76767622",
//           type: 2,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 107,
//           displayText: "Company Email",
//           value: "elias@gnail.con",
//           type: 13,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 108,
//           displayText: "Purpose Of Suyool Account",
//           value: "1",
//           type: 7,
//           isModifiable: false,
//           options: [
//             {
//               optionId: 1,
//               name: "Payroll Solution",
//               nestedFields: [],
//             },
//             {
//               optionId: 2,
//               name: "Merchant POS",
//               nestedFields: [],
//             },
//             {
//               optionId: 3,
//               name: "Cash collection",
//               nestedFields: [],
//             },
//           ],
//         },
//       ],
//       "OWNERS INFORMATION": [
//         {
//           fieldId: 110,
//           displayText: "Person In Charge (Authorized Signatory)",
//           value: "Tetststst",
//           type: 1,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 111,
//           displayText: "Owner Mobile Number",
//           value: "78787874",
//           type: 2,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 112,
//           displayText: "Sole Signature",
//           value: "1",
//           type: 5,
//           isModifiable: false,
//           options: [
//             {
//               optionId: 1,
//               name: "Yes",
//               nestedFields: [],
//             },
//             {
//               optionId: 2,
//               name: "No",
//               nestedFields: [],
//             },
//           ],
//         },
//       ],
//       "CONTACT PERSON": [
//         {
//           fieldId: 114,
//           displayText: "Contact Full Name",
//           value: "Tets",
//           type: 1,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 115,
//           displayText: "Contact Phone Number",
//           value: "78787879",
//           type: 2,
//           isModifiable: false,
//           options: [],
//         },
//         {
//           fieldId: 116,
//           displayText: "Contact Email",
//           value: "gagaga@gmail.com",
//           type: 13,
//           isModifiable: false,
//           options: [],
//         },
//       ],
//     },
//   },
};

const legalEnrollment = createSlice({
  name: "legalEnrollment",
  initialState,
  reducers: {
    settingData: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },

    settingObjectData: (state, action) => {
      const { mainField, field, value } = action.payload;
      state[mainField][field] = value;
    },

    updateFieldValue: (state, action) => {
      const { stepId, fieldId, value } = action.payload;
      const stepKey = `getfieldByStepId-${stepId}`;
      const fields = state[stepKey]?.fields;
      if (!fields) return;
      const f = fields.find((x) => x.id === fieldId);
      if (f) f.value = value;
    },
  },
});

export const { settingData, settingObjectData, updateFieldValue } =
  legalEnrollment.actions;
export default legalEnrollment.reducer;
